import { AUTHORITIES as APP_AUTHORITIES } from 'domain/fuse/auth/constants';
import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/DASHBOARD`;

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/shipments/activities`;

export const TRACKING_ENDPOINT = `${SHIPPING_EDGE}/api/shipments/trackshipment`;

export const REDUCER_NAME = 'shipperDashboard';

export const AUTHORITIES = [
  APP_AUTHORITIES.ACCOUNT_ADMIN,
  APP_AUTHORITIES.OPERATOR,
  APP_AUTHORITIES.SHIPPER,
];

export const ROUTES = {
  ROOT: '/shippers/:shipperId/dashboard',
};
export const PICKUP_ICON = 'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_redP.png';
export const DROPOFF_ICON = 'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_greenD.png';
